import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../services/config.service';
import { RequestService } from '../../services/request.service';

@Injectable()
export class InboxService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    list(params: any, url: string): Observable<any> {
        return this.requestService.get(url, params);
    }

    getConversationDetails(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').sahara.conversation.details.api + '/' + id;
        return this.requestService.get(url);
    }
    getAccountDetails(details): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.accounts.getAccountNameByDomain.api;
        return this.requestService.post(url, details);
    }
    createMessage(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').sahara.message.create.api;
        return this.requestService.post(url, details);
    }
    deleteMessage(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').sahara.message.delete.api;
        return this.requestService.post(url, details);
    }
    createConversation(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').sahara.conversation.create.api;
        return this.requestService.post(url, details);
    }

    informSellerAboutConversation(domain: String): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.informSellerAboutConversation.api + domain;
        return this.requestService.post(url, {});
    }
    informBuyerAboutMessage(conversationId: String): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.informAboutMessage.api + conversationId;
        return this.requestService.post(url, {});
    }
    changeConversationStatus(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').sahara.conversation.markAsRead.api;
        return this.requestService.post(url, details);
    }
    archiveConversation(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').sahara.conversation.archive.api;
        return this.requestService.post(url, details);
    }
    countNewMessages(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').sahara.conversation.countAllNew.api;
        return this.requestService.get(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/inbox/inbox.service.ts